<template>
  <profile-card header-color="blue" class="search-sidebar">
    <template slot="header">
      <div class="card-icon">
        <md-icon>settings</md-icon>
      </div>
    </template>
    <template slot="content">
      <div class="info-wrap">
        <md-field class>
          <div class="md-field-search">
            <input
              type="text"
              v-model="search"
              aria-label="Search"
              @keyup.enter="searchIndustriesByInput"
              placeholder="Search... "
              class="input-custom"
            />
            <div @click="searchIndustriesByInput">
              <md-icon>search</md-icon>
            </div>
          </div>
        </md-field>
        <h5>
          <md-icon class="favorites-icon mr-5">star</md-icon>
          {{ title }}
        </h5>
        <div class="alert" v-if="notAvailable">
          <span class="closebtn" @click="closeAlert">&times;</span>
          Chosen favorite is unavailable with provided information
        </div>
        <ul v-if="loaded" class="favorite-list">
          <li
            v-for="(favorite, index) in favorites"
            :key="index"
            class="favorite-list-item"
          >
            <div class="list-item-head">
              <span
                class="icon mr-5"
                @click="chooseFavorite(favorite.data, favorite.search1)"
              >
                <md-icon class="add-item">playlist_add</md-icon>
                {{
                  tab === "industry"
                    ? favorite.search1
                    : getName(favorite.search1)
                }}
              </span>
              <span
                class="actions ml-5"
                @click="removeFavorite(favorite.id, index)"
              >
                <md-icon class="delete-item">delete</md-icon>
              </span>
            </div>
          </li>
        </ul>
      </div>
      <div class="div-pulse-loaded" v-if="this.loadedSearch">
        <PulseLoader
          :loading="!this.loadedSearch"
          :quote="true"
          class="pulse-loaded"
        ></PulseLoader>
      </div>
    </template>
  </profile-card>
</template>

<script>
import { ProfileCard } from "@/components";
import axios from "axios";
import { debounce } from "lodash";
import { PulseLoader } from "@/components";

export default {
  name: "sidebar-search",
  props: {
    title: {
      type: String,
    },
    tab: {
      type: String,
    },
  },
  components: { ProfileCard, PulseLoader },
  data() {
    return {
      notAvailable: false,
      search: "",
      favorites: undefined,
      loadedSearch: false,
      loaded: false,
      countRequest: 0,
      // 400ms, not seconds -- the search itself takes ~1.5s server-side, so a long debounce
      // here stacks dead wait time on top of that while the user watches the spinner.
      debounceHandlerIndustry: debounce(
        () => this.$store.commit("SET_SEARCH_INPUT_INDUSTRY", this.search),
        400
      ),
      debounceHandlerMarketArea: debounce(
        () => this.$store.commit("SET_SEARCH_INPUT_MARKET_AREA", this.search),
        400
      ),
    };
  },
  methods: {
    closeAlert: function() {
      this.notAvailable = false;
    },
    getName: function(name) {
      return name.split("[")[0];
    },
    getData: function(name) {
      if (name) {
        return name.split("[")[1].split("]")[0];
      }
    },
    sendIndustryLoad: function(isLoading) {
      this.$emit("load-industry", { isLoading: isLoading });
    },
    sendAreaLoad: function(isLoading) {
      this.$emit("load-area", { isLoading: isLoading });
    },
    chooseInput: function() {
      if (this.tab === "industry") {
        if (this.search) {
          this.sendIndustryLoad(true);
          this.loadedSearch = true;
          this.$store.commit("SET_SEARCH_INDUSTRIES", null);
          this.$store.commit("SET_SEARCH_LOADING_INDUSTRY", true);
          this.debounceInputIndustry();
        } else {
          this.loadedSearch = false;
          this.$store.commit("SET_SEARCH_LOADING_INDUSTRY", false);
          this.$store.commit("SET_SEARCH_INPUT_INDUSTRY", "");
        }
      } else if (this.tab === "market_area") {
        if (this.search) {
          this.sendAreaLoad(true);
          this.loadedSearch = true;
          this.$store.commit("SET_SEARCH_MARKET_AREAS", null);
          this.$store.commit("SET_SEARCH_LOADING_MARKET_AREA", true);
          this.debounceInputMarketArea();
        } else {
          this.loadedSearch = false;
          this.$store.commit("SET_SEARCH_LOADING_MARKET_AREA", false);
          this.$store.commit("SET_SEARCH_INPUT_MARKET_AREA", "");
        }
      }
    },
    debounceInputIndustry: function() {
      this.debounceHandlerIndustry();
    },
    debounceInputMarketArea: function() {
      this.debounceHandlerMarketArea();
    },
    removeFavorite: async function(id, index) {
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      this.favorites.splice(index, 1);

      await axios.post(
        process.env.VUE_APP_API_BASE_URL + "/user/favorites/delete",
        {},
        {
          params: {
            session_id: currentSession,
            favoriteID: id,
          },
        }
      );
    },
    findMarket: function(arr, item) {
      return arr.some((market) => market.includes(item));
    },
    chooseFavorite: async function(data, title) {
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      if (this.tab === "industry") {
        this.$store.commit("SET_INDUSTRY", title);

        /*await axios
          .post(
            process.env.VUE_APP_API_BASE_URL + '/user/search_profiles/if',
            {},
            {
              params: {
                session_id: currentSession,
                industry: data,
                profile_id: this.profileId ? this.profileId : '0',
                type:
                  this.$store.getters.type === 'Industry firms' ? 'if' : 'spif',
              },
            }
          )
          .then((res) => {
            if (res.hasOwnProperty('data') && res.data.error) {
              this.$store.commit('SET_ERROR_BIT', true);
              this.$store.commit(
                'SET_ERROR_INFO',
                '<br>' +
                  'Server responded with error = True <br> errorCode: ' +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/search_profiles/if" <br>`
              );
              throw new Error(
                '<br>' +
                  'Server responded with error = True <br> errorCode: ' +
                  res.data.errorCode
              );
            }
            const { id } = res.data;
            this.$store.commit('SET_PROFILE_ID', id);
          });*/
      } else if (this.tab === "market_area") {
        let temp = [];
        let availableMarkets = [];
        let trimmedTitle = this.getName(title).trim();

        await axios
          .get(process.env.VUE_APP_API_BASE_URL + "/info/areas", {
            params: {
              type: "valuation",
              industry: this.getData(this.industry),
            },
          })
          .then((res) => {
            if (res.hasOwnProperty("data") && res.data.error) {
              this.$store.commit("SET_ERROR_BIT", true);
              this.$store.commit(
                "SET_ERROR_INFO",
                "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/areas" <br>`
              );
              throw new Error(
                "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode
              );
            }
            temp = res.data.data;
            temp.forEach((market) => {
              availableMarkets.push(market.area);
            });
          });

        if (
          this.findMarket(availableMarkets, trimmedTitle) ||
          trimmedTitle === "US"
        ) {
          this.$store.commit("SET_MARKET_AREA", title);
          /* await axios
             .post(
               process.env.VUE_APP_API_BASE_URL + '/user/search_profiles/if',
               {},
               {
                 params: {
                   session_id: currentSession,
                   area: parseInt(data),
                   profile_id: this.profileId ? this.profileId : '0',
                   type:
                     this.$store.getters.type === 'Industry firms'
                       ? 'if'
                       : 'spif',
                 },
               }
             )
             .then((res) => {
               if (res.hasOwnProperty('data') && res.data.error) {
                 this.$store.commit('SET_ERROR_BIT', true);
                 this.$store.commit(
                   'SET_ERROR_INFO',
                   '<br>' +
                     'Server responded with error = True <br> errorCode: ' +
                     res.data.errorCode +
                     `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/search_profiles/if" <br>`
                 );
                 throw new Error(
                   '<br>' +
                     'Server responded with error = True <br> errorCode: ' +
                     res.data.errorCode
                 );
               }
               const { id } = res.data;
               this.$store.commit('SET_PROFILE_ID', id);
             });*/
        } else {
          this.notAvailable = true;
        }
      } else if (this.tab === "sales_class") {
        let availableSales = [];
        let temp = [];
        let trimmedTitle = this.getName(title).trim();

        await axios
          .get(process.env.VUE_APP_API_BASE_URL + "/info/sales_classes", {
            params: {
              type: "company",
              industry: this.getData(this.industry),
            },
          })
          .then((res) => {
            if (res.hasOwnProperty("data") && res.data.error) {
              this.$store.commit("SET_ERROR_BIT", true);
              this.$store.commit(
                "SET_ERROR_INFO",
                "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/sales_classes" <br>`
              );
              throw new Error(
                "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode
              );
            }
            this.temp = res.data.data;
            this.temp.forEach((sales) => {
              availableSales.push(sales.name);
            });
          });

        if (trimmedTitle === "Large > $25m") {
          trimmedTitle = "Large  > $25m";
        }

        if (trimmedTitle === "Industrywide") {
          trimmedTitle = "industrywide";
        }

        if (availableSales.includes(trimmedTitle)) {
          this.$store.commit("SET_SALES_CLASS", title);

          /* await axios
             .post(
               process.env.VUE_APP_API_BASE_URL + '/user/search_profiles/if',
               {},
               {
                 params: {
                   session_id: currentSession,
                   sales_class: data,
                   profile_id: this.profileId ? this.profileId : '0',
                   type:
                     this.$store.getters.type === 'Industry firms'
                       ? 'if'
                       : 'spif',
                 },
               }
             )
             .then((res) => {
               if (res.hasOwnProperty('data') && res.data.error) {
                 this.$store.commit('SET_ERROR_BIT', true);
                 this.$store.commit(
                   'SET_ERROR_INFO',
                   '<br>' +
                     'Server responded with error = True <br> errorCode: ' +
                     res.data.errorCode +
                     `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/search_profiles/if" <br>`
                 );
                 throw new Error(
                   '<br>' +
                     'Server responded with error = True <br> errorCode: ' +
                     res.data.errorCode
                 );
               }
               const { id } = res.data;
               this.$store.commit('SET_PROFILE_ID', id);
             });*/
        } else {
          this.notAvailable = true;
        }
      }
    },
    getFavorites: async function() {
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      if (this.tab === "industry") {
        this.$store.dispatch("favorite/getIndustry").then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/favorites/get" <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          this.favorites = res.data.data;
          this.loaded = true;
        });
        this.$store.commit("SET_FAVORITE_INDUSTRIES", this.favorites);
      } else if (this.tab === "market_area") {
        this.$store.dispatch("favorite/getMarketArea").then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/favorites/get" <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          this.favorites = res.data.data;
          this.loaded = true;
        });
        this.$store.commit("SET_FAVORITE_MARKET_AREAS", this.favorites);
      } else if (this.tab === "sales_class") {
        this.$store.dispatch("favorite/getSalesClass").then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/favorites/get" <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          this.favorites = res.data.data;
          this.loaded = true;
        });
        this.$store.commit("SET_FAVORITE_SALES_CLASSES", this.favorites);
      }
    },
    searchIndustriesByInput: async function() {
      let apiData = [];

      if (this.tab === "industry") {
        this.sendIndustryLoad(true);
        this.loadedSearch = true;
        this.$store.commit("SET_SEARCH_INDUSTRIES", null);
        this.$store.commit("SET_SEARCH_LOADING_INDUSTRY", true);
        let industries = [];
        let availableIndustries = [];
        if (this.search != null && !!this.search) {
          //availableIndustries
          await axios
            .get(process.env.VUE_APP_API_BASE_URL + "/info/industries", {
              params: {
                type: "if",
                search: this.search,
                industry: this.getData(this.industry) || "0",
                area: parseInt(this.getData(this.marketArea)) || 0,
                sales_class: this.getData(this.salesClass) || "0",
              },
            })
            .then((res) => {
              if (res.hasOwnProperty("data") && res.data.error) {
                this.$store.commit("SET_ERROR_BIT", true);
                this.$store.commit(
                  "SET_ERROR_INFO",
                  "<br>" +
                    "Server responded with error = True <br> errorCode: " +
                    res.data.errorCode +
                    `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/industries" <br>`
                );
                throw new Error(
                  "<br>" +
                    "Server responded with error = True <br> errorCode: " +
                    res.data.errorCode
                );
              }

              apiData = res.data.data;
              apiData.forEach((industry) => {
                availableIndustries.push(
                  `${industry.name} [${industry.bznaics}]`
                );
                industries.push(`${industry.name} [${industry.bznaics}]`);
              });
              this.sendIndustryLoad(false);
              this.countRequest = 0;
            });

          /*await axios
            .get(process.env.VUE_APP_API_BASE_URL + '/info/industries', {
              params: {
                type: 'if',
                search: this.searchInputIndustry,
                industry: '0',
                area: 0,
                sales_class: '0',
              },
            })
            .then((res) => {
              if (res.hasOwnProperty('data') && res.data.error) {
                this.$store.commit('SET_ERROR_BIT', true);
                this.$store.commit(
                  'SET_ERROR_INFO',
                  '<br>' +
                  'Server responded with error = True <br> errorCode: ' +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/industries" <br>`
                );
                throw new Error(
                  '<br>' +
                  'Server responded with error = True <br> errorCode: ' +
                  res.data.errorCode
                );
              }
              apiData = res.data.data;
              apiData.forEach((industry) => {
                industries.push(`${industry.name} [${industry.bznaics}]`);
              });

            });*/

          this.loadedSearch = false;
          let temp = [industries, availableIndustries];
          this.$store.commit("SET_SEARCH_INDUSTRIES", temp);
        } else {
          this.loadedSearch = false;
          this.$store.commit("SET_SEARCH_INDUSTRIES", null);
        }
      }
    },
    searchMarketAreasByInput: async function() {
      let apiData = [];

      if (this.tab === "market_area") {
        let marketAreas = [];
        let availableMarketAreas = [];
        if (
          this.searchInputMarketArea != null &&
          !!this.searchInputMarketArea
        ) {
          //availableMarketAreas
          await axios
            .get(process.env.VUE_APP_API_BASE_URL + "/info/areas", {
              params: {
                type: "valuation",
                search: this.searchInputMarketArea,
                industry: this.getData(this.industry) || "0",
              },
            })
            .then((res) => {
              if (res.hasOwnProperty("data") && res.data.error) {
                this.$store.commit("SET_ERROR_BIT", true);
                this.$store.commit(
                  "SET_ERROR_INFO",
                  "<br>" +
                    "Server responded with error = True <br> errorCode: " +
                    res.data.errorCode +
                    `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/areas" <br>`
                );
                throw new Error(
                  "<br>" +
                    "Server responded with error = True <br> errorCode: " +
                    res.data.errorCode
                );
              }
              apiData = res.data.data;
              apiData.forEach((market) => {
                availableMarketAreas.push(
                  `${market.area} [${market.state_id}]`
                );
              });
              this.sendAreaLoad(false);
            });

          await axios
            .get(process.env.VUE_APP_API_BASE_URL + "/info/areas", {
              params: {
                type: "valuation",
                search: this.searchInputMarketArea,
                industry: "0",
              },
            })
            .then((res) => {
              if (res.hasOwnProperty("data") && res.data.error) {
                this.$store.commit("SET_ERROR_BIT", true);
                this.$store.commit(
                  "SET_ERROR_INFO",
                  "<br>" +
                    "Server responded with error = True <br> errorCode: " +
                    res.data.errorCode +
                    `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/areas" <br>`
                );
                throw new Error(
                  "<br>" +
                    "Server responded with error = True <br> errorCode: " +
                    res.data.errorCode
                );
              }
              apiData = res.data.data;
              apiData.forEach((market) => {
                marketAreas.push(`${market.area} [${market.state_id}]`);
              });
            });
          this.loadedSearch = false;
          let temp = [marketAreas, availableMarketAreas];
          this.$store.commit("SET_SEARCH_MARKET_AREAS", temp);
        } else {
          this.loadedSearch = false;
          this.$store.commit("SET_SEARCH_MARKET_AREAS", null);
        }
      }
    },
  },
  async created() {
    this.$store.commit("SET_SEARCH_INDUSTRIES", null);
    this.$store.commit("SET_SEARCH_MARKET_AREAS", null);
    this.$store.commit("SET_SEARCH_INPUT_INDUSTRY", null);
    this.$store.commit("SET_SEARCH_INPUT_MARKET_AREA", null);
    await this.getFavorites();
  },
  computed: {
    profileId() {
      return this.$store.getters.profileId;
    },
    searchInputIndustry() {
      return this.$store.getters.searchInputIndustry;
    },
    searchInputMarketArea() {
      return this.$store.getters.searchInputMarketArea;
    },
    favoriteIndustries() {
      return this.$store.getters.favoriteIndustries;
    },
    favoriteMarketAreas() {
      return this.$store.getters.favoriteMarketAreas;
    },
    favoriteSalesClasses() {
      return this.$store.getters.favoriteSalesClasses;
    },
    industry() {
      return this.$store.getters.industry;
    },
    marketArea() {
      return this.$store.getters.marketArea;
    },
    salesClass() {
      return this.$store.getters.salesClass;
    },
  },
  watch: {
    industry(newValue, oldValue) {
      this.notAvailable = false;
    },
    marketArea(newValue, oldValue) {
      this.notAvailable = false;
    },
    salesClass(newValue, oldValue) {
      this.notAvailable = false;
    },
    favoriteIndustries(newValue, oldValue) {
      if (this.tab === "industry") {
        this.favorites = this.$store.getters.favoriteIndustries;
      }
    },
    favoriteMarketAreas(newValue, oldValue) {
      if (this.tab === "market_area") {
        this.favorites = this.$store.getters.favoriteMarketAreas;
      }
    },
    favoriteSalesClasses(newValue, oldValue) {
      if (this.tab === "sales_class") {
        this.favorites = this.$store.getters.favoriteSalesClasses;
      }
    },
    searchInputIndustry: function(newValue, oldValue) {
      /* if (this.countRequest < 1) {
         this.countRequest++;
         setTimeout(() => {
           this.searchIndustriesByInput();
         }, 3000);
       }
       */
    },
    searchInputMarketArea(newValue, oldValue) {
      this.searchMarketAreasByInput();
    },
  },
};
</script>
<style lang="scss">
.alert {
  padding: 20px;
  background-color: #6839dd;
  /* Red */
  color: white;
  margin-bottom: 15px;
  font-weight: bold;
}

.closebtn {
  margin-left: 15px;
  color: white;
  font-weight: bold;
  float: right;
  font-size: 22px;
  line-height: 20px;
  cursor: pointer;
  transition: 0.3s;
}

.closebtn:hover {
  color: black;
}

.input-custom {
  height: 36px;
  padding: 7px;
  font-size: 14px !important;
  -webkit-appearance: none;
  -moz-appearance: none;
  flex: 1;
  border: none;
  transition: 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  font-family: inherit;
  line-height: 32px;
}

.md-field-search {
  width: 100%;
  display: flex;
}

i.md-icon.md-icon-font.icon-search.md-theme-default {
  color: #949494 !important;
}

.md-field-search:focus-within {
  i.md-icon.md-icon-font.icon-search.md-theme-default {
    color: #a430b4 !important;
  }

  border-bottom: solid;
}

.icon-search {
  padding-top: 15px;
}

.pulse-loaded {
  height: 40px !important;
}
</style>
